{
    "(save {highestYearlyDiscount}%)": "חסכו {highestYearlyDiscount}%",
    "{amount} days free": "{amount} ימים חינם",
    "{amount} off": "הנחה {amount}",
    "{amount} off for first {number} months.": "{amount} הנחה ל {number} חודשים הראשונים.",
    "{amount} off for first {period}.": "{amount} הנחה ל {period} הראשונים.",
    "{amount} off forever.": "{amount} הנחה לכל החיים.",
    "{buyerName} has gifted you a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_one": "",
    "{buyerName} has gifted you a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_two": "",
    "{buyerName} has gifted you a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_other": "",
    "{buyerName} has gifted you a <strong>{duration}-year</strong> {tierName} membership to {siteTitle}": "",
    "{discount}% discount": "{discount}% הנחה",
    "{duration} membership": "",
    "{memberEmail} will no longer receive {newsletterName} newsletter.": "{memberEmail} לא יקבל עוד את ניוזלטר {newsletterName}.",
    "{memberEmail} will no longer receive emails when someone replies to your comments.": "{memberEmail} לא יקבל עוד התראות כאשר מישהו עונה על תגובות שלכם.",
    "{memberEmail} will no longer receive this newsletter.": "{memberEmail} לא יקבל עוד את ניוזלטר זה.",
    "{memberEmail} will no longer receive updates & announcements.": "",
    "{months} month": "",
    "{months} months": "",
    "{months} months free": "",
    "{tierName} membership": "",
    "{trialDays} days free": "{trialDays} ימים חינם",
    "{years} years": "",
    "+1 (123) 456-7890": "+1 (123) 456-7890",
    "1 month": "",
    "1 month free": "",
    "1 year": "",
    "A gift, just for you": "",
    "Access your RSS feeds": "",
    "Account": "חשבון",
    "Account details updated successfully": "פרטי החשבון עודכנו בהצלחה",
    "Account settings": "הגדרות חשבון",
    "Add a personal note": "",
    "Add a short note to go with your gift": "",
    "After a free trial ends, you will be charged the regular price for the tier you've chosen. You can always cancel before then.": "לאחר תום תקופת הניסיון החינמית, תחויבו במחיר הרגיל של התוכנית שבחרתם. תוכלו לבטל בכל עת לפני כן.",
    "Already a member?": "כבר רשומים?",
    "An error occurred": "קרתה שגיאה",
    "An unexpected error occured. Please try again or <a>contact support</a> if the error persists.": "תקלה לא צפויה התרחשה. נסו שוב או <a>צרו קשר עם התמיכה</a> אם התקלה ממשיכה.",
    "Back": "חזרה",
    "Back to Log in": "חזרה לכניסה",
    "Before you go": "",
    "Billing info & receipts": "",
    "Black Friday": "בלאק פריידי",
    "Bluesky": "",
    "Buy": "",
    "Buying for someone else?": "",
    "Cancel anytime.": "בטלו בכל עת",
    "Cancel subscription": "ביטול מנוי",
    "Canceled": "",
    "Cancellation reason": "סיבת הביטול",
    "Change": "שינוי",
    "Change plan": "שינוי תוכנית",
    "Check spam & promotions folders": "בדקו את תיבת הספאם והפרסומות",
    "Check with your mail provider": "בדקו עם ספק המייל שלכם",
    "Check your inbox to verify email update": "בדקו את תיבת המייל שלכם כדי לאשר את עדכון המייל",
    "Choose": "בחרו",
    "Choose a date from today onwards": "",
    "Choose a date within the next year": "",
    "Choose a delivery date": "",
    "Choose a different plan": "בחרו מנוי אחר",
    "Choose a plan": "בחרו תוכנית",
    "Choose a tier": "",
    "Choose your newsletters": "בחרו את הניוזלטרים שלכם",
    "Click here to retry": "לחצו כאן כדי לנסות שוב",
    "Click the confirmation link in your inbox to finish redeeming your membership. If it doesn't arrive within 3 minutes, check your spam folder.": "",
    "Close": "סגירה",
    "Code": "",
    "Comment preferences updated.": "",
    "Comments": "תגובות",
    "Complimentary": "חינם",
    "Confirm": "אישור",
    "Confirm cancellation": "אשרו את הביטול",
    "Confirm subscription": "אישור הרשמה",
    "Contact support": "צרו קשר עם התמיכה",
    "Continue": "המשך",
    "Continue subscription": "המשך מנוי",
    "Continue to delivery details": "",
    "Continue to payment": "",
    "Continue with a paid subscription anytime. Your remaining gift period will be added as a free trial.": "",
    "Copied": "",
    "Copy": "",
    "Copy link": "",
    "Could not create Stripe billing portal session": "",
    "Could not create Stripe checkout session": "לא ניתן ליצור סשן של קופה של סטרייפ",
    "Could not sign in. Login link expired.": "כניסה נכשלה. פג תוקפו של לינק הכניסה",
    "Could not update email! Invalid link.": "עדכון המייל נכשל! לינק לא תקין.",
    "Create a new contact": "צרו איש קשר חדש",
    "Current plan": "תוכנית נוכחית",
    "Delete account": "מחיקת חשבון",
    "Delivery date": "",
    "Delivery method": "",
    "Didn't mean to do this? Manage your preferences <button>here</button>.": "התחרטתם? ניתן לנהל את ההעדפות <button>כאן</button>.",
    "Don't have an account?": "אין לכם חשבון?",
    "Edit": "עריכה",
    "Email": "מייל",
    "Email confirmation link expired.": "",
    "Email it to them": "",
    "Email newsletter": "ניוזלטר במייל",
    "Email newsletter settings updated": "הגדרות ניוזלטר במייל עודכנו",
    "Email preferences": "העדפות מייל",
    "Email preferences updated.": "",
    "Emails": "מיילים",
    "Emails disabled": "מיילים מושבתים",
    "Ends {offerEndDate}": "מסתיים ב {offerEndDate}",
    "Enjoy {amountOff} off forever.": "",
    "Enjoy {months} free months on us.": "",
    "Enjoy {months} free months on us. You won't be charged until {newBillingDate}.": "",
    "Enjoy a free month on us.": "",
    "Enjoy a free month on us. You won't be charged until {newBillingDate}.": "",
    "Enter code above": "",
    "Enter the recipient's email address": "",
    "Enter your email address": "כתבו את כתובת המייל שלכם",
    "Enter your name": "רשמו את השם שלכם",
    "Error": "שגיאה",
    "Expires {expiryDate}": "יפוג תוקפו ב {expiryDate}",
    "Facebook": "",
    "Failed to cancel subscription, please try again": "ביטול המנוי נכשל, נסו שוב",
    "Failed to log in, please try again": "הכניסה נכשלה, נסו שוב",
    "Failed to log out, please try again": "היציאה נכשלה, נסו שוב",
    "Failed to open billing portal, please try again": "",
    "Failed to process checkout, please try again": "עיבוד הקופה נכשל, נסו שוב",
    "Failed to send magic link email": "שליחת מייל עם לינק קסם נכשלה",
    "Failed to send verification email": "שליחת מייל אימות נכשלה",
    "Failed to sign up, please try again": "ההרשמה נכשלה, נסו שוב",
    "Failed to update account data": "עדכון נתוני החשבון נכשל",
    "Failed to update account details": "עדכון פרטי החשבון נכשל",
    "Failed to update billing information, please try again": "",
    "Failed to update newsletter settings": "עדכון הגדרות הניוזלטר נכשל",
    "Failed to update subscription, please try again": "עדכון המנוי נכשל, נסו שוב",
    "Failed to verify code, please try again": "",
    "For a friend or colleague": "",
    "Forever": "לכל החיים",
    "Free Trial – Ends {trialEnd}": "תקופת ניסיון חינם – מסתיים ב {trialEnd}",
    "From": "",
    "Get help": "בקשו עזרה",
    "Get in touch for help": "צרו קשר לעזרה",
    "Get notified when someone replies to your comment": "קבלו התראה כאשר עונים לתגובה שלכם",
    "Gift a membership": "",
    "Gift could not be redeemed": "",
    "Gift details": "",
    "Gift duration": "",
    "Gift link copied to clipboard": "",
    "Gift membership": "",
    "Gift redeemed! You're all set.": "",
    "Gift subscription": "",
    "Gift subscriptions are not available right now.": "",
    "Gift value": "",
    "Give feedback on this post": "תנו פידבק על הפוסט הזה",
    "Help! I'm not receiving emails": "עזרה! אני לא מקבל/ת מיילים",
    "Here are a few other sites you may enjoy.": "הנה כמה אתרים נוספים שאולי תהנו מהם.",
    "Hi {recipientName},": "",
    "Hide details": "",
    "How would you like to share this gift?": "",
    "I'll share it myself": "",
    "If a newsletter is flagged as spam, emails are automatically disabled for that address to make sure you no longer receive any unwanted messages.": "אם ניוזלטר מסוים מסומן כספאם, המיילים מושבתים אוטומטית עבור כתובת זו כדי לוודא שלא תקבלו עוד הודעות לא רצויות.",
    "If the spam complaint was accidental, or you would like to begin receiving emails again, you can resubscribe to emails by clicking the button on the previous screen.": "אם תלונת הספאם הייתה בטעות, או שתרצו להתחיל לקבל מיילים שוב, ניתן להירשם מחדש למיילים על ידי לחיצה על הכפתור במסך הקודם.",
    "If you cancel your subscription now, you will continue to have access until {periodEnd}.": "אם תבטלו את המנוי כעת, תמשיכו לקבל גישה עד {periodEnd}.",
    "If you have a corporate or government email account, reach out to your IT department and ask them to allow emails to be received from {senderEmail}": "אם יש לכם חשבון מייל עסקי או ממשלתי, פנו למחלקת ה-IT שלכם ובקשו מהם לאפשר קבלת מיילים מאת {senderEmail}",
    "If you have an account, a login link has been sent to your inbox. If it doesn't arrive in 3 minutes, be sure to check your spam folder.": "לינק לכניסה נשלח לתיבת המייל שלכם. במידה ואינו מגיע תוך 3 דקות, בדקו את תיבת הספאם שלכם.",
    "If you have an account, an email has been sent to {submittedEmailOrInbox}. Click the link inside or enter your code below.": "",
    "If you would like to start receiving emails again, the best next steps are to check your email address on file for any issues and then click resubscribe on the previous screen.": "אם תרצו להתחיל לקבל מיילים שוב, הצעדים הטובים ביותר הם לבדוק את כתובת המייל שלכם וללחוץ על הכפתור להרשמה מחדש במסך הקודם.",
    "If you're not receiving the email newsletter you've subscribed to, here are a few things to check.": "אם אתם לא מקבלים את ניוזלטר המייל שנרשמתם אליו, כאן כמה דברים לבדוק.",
    "If you've completed all these checks and you're still not receiving emails, you can reach out to get support by contacting {supportAddress}.": "אם ביצעתם את כל הבדיקות הללו ועדיין לא מקבלים מיילים, ניתן לפנות לתמיכה על ידי פנייה אל {supportAddress}.",
    "In the event a permanent failure is received when attempting to send a newsletter, emails will be disabled on the account.": "כאשר מתקבלת תקלה קבועה בניסיון לשלוח ניוזלטר, המיילים יושבתו בחשבון.",
    "In your email client add {senderEmail} to your contacts list. This signals to your mail provider that emails sent from this address should be trusted.": "בספק המייל שלכם הוסיפו את {senderEmail} לרשימת אנשי הקשר שלכם. זה מסמן לספק המייל שלכם שמיילים שנשלחים מכתובת זו צריכים להיות מהימנים.",
    "Invalid email address": "כתובת מייל לא תקינה",
    "Invalid verification code": "",
    "Jamie Larson": "ג'יימי לרסון",
    "jamie@example.com": "jamie@example.com",
    "Less like this": "פחות כאלה",
    "LinkedIn": "",
    "Make sure emails aren't accidentally ending up in the Spam or Promotions folders of your inbox. If they are, click on \"Mark as not spam\" and/or \"Move to inbox\".": "ודאו שהמיילים לא מגיעים בטעות לתיקיית הספאם או הפרסומות בתיבת המייל שלכם. אם הם מגיעים, לחצו על \"סמן כלא ספאם\" ו/או \"העבר לתיקיית הנכנסות\".",
    "Manage": "ניהול",
    "Maybe later": "אולי מאוחר יותר",
    "Membership details": "",
    "Memberships from this email domain are currently restricted.": "",
    "Memberships unavailable, contact the owner for access.": "מנויים לא זמינים, פנו לבעל האתר לגישה.",
    "month": "חודש",
    "Monthly": "חודשי",
    "More like this": "עוד כאלה",
    "More options": "",
    "Name": "שם",
    "Need more help? Contact support": "צריכים עזרה נוספת? צרו קשר עם התמיכה",
    "Newsletters can be disabled on your account for two reasons: A previous email was marked as spam, or attempting to send an email resulted in a permanent failure (bounce).": "ניוזלטרים יכולים להיות מושבתים בחשבון שלכם משני סיבות: מייל קודם סומן כספאם, או ניסיון לשלוח מייל גרם לתקלה קבועה (הקפצה).",
    "No member exists with this e-mail address.": "לא קיים חבר עם כתובת המייל הזו.",
    "No thanks, I want to cancel": "",
    "Not ready to share? We've also emailed a copy to your inbox.": "",
    "Not receiving emails?": "לא מקבלים מיילים?",
    "Now": "",
    "Now check your email!": "עכשיו בדקו את תיבת המייל שלכם!",
    "Occasional updates from {siteTitle}": "",
    "Once resubscribed, if you still don't see emails in your inbox, check your spam folder. Some inbox providers keep a record of previous spam complaints and will continue to flag emails. If this happens, mark the latest newsletter as 'Not spam' to move it back to your primary inbox.": "אחרי שתירשמו מחדש, אם אתם עדיין לא רואים מיילים בתיבת הנכנסות שלכם, בדקו את תיבת הספאם שלכם. חלק מספקי תיבת המייל שומרים רשומה של תלונות ספאם קודמות וימשיכו לסמן מיילים. אם זה קורה, סמנו את הניוזלטר האחרון כ\"לא ספאם\" כדי להחזיר אותו לתיבת הנכנסות הראשית שלכם.",
    "Open AOL Mail": "",
    "Open email": "",
    "Open Feedbin": "",
    "Open Gmail": "",
    "Open Hey": "",
    "Open iCloud Mail": "",
    "Open Mail.ru": "",
    "Open Outlook": "",
    "Open Proton Mail": "",
    "Open Yahoo Mail": "",
    "Optional message": "",
    "Permanent failure (bounce)": "תקלה קבועה (הקפצה)",
    "Phone number": "מספר טלפון",
    "Plan": "תוכנית",
    "Plan checkout was cancelled.": "רכישת התוכנית בוטלה.",
    "Plan upgrade was cancelled.": "שדרוג התוכנית בוטל.",
    "Please contact {supportAddress} to adjust your complimentary subscription.": "צרו קשר עם {supportAddress} כדי להתאים את המנוי החינמי שלכם.",
    "Please enter {fieldName}": "בבקשה הזינו {fieldName}",
    "Please fill in required fields": "אנא מלאו את השדות הנדרשים",
    "Podcasts": "",
    "Re-enable emails": "אפשרו שוב מיילים",
    "Recipient's email": "",
    "Recipient's name": "",
    "Recommendations": "המלצות",
    "Redeem your gift": "",
    "Redeem your membership": "",
    "Redeeming...": "",
    "Renews at {price}.": "מתחדש ב {price}.",
    "Resume subscription": "",
    "Retry": "נסו שנית",
    "Save": "שמירה",
    "Save {amountOff} on your next {durationInMonths} billing cycles. Then {currency}{originalPrice}/{cadence}.": "",
    "Save {amountOff} on your next billing cycle. Then {currency}{originalPrice}/{cadence}.": "",
    "Send the link below to share it with whoever you'd like.": "",
    "Sending login link...": "שולחים לינק לכניסה...",
    "Sending...": "שולחים...",
    "Share": "",
    "Share a full membership to {siteTitle} with a friend or colleague": "",
    "Share it yourself": "",
    "Show all": "הציגו הכל",
    "Sign in": "כניסה",
    "Sign out": "יציאה",
    "Sign up": "הרשמה",
    "Signup error: Invalid link": "שגיאת הרשמה: לינק לא תקין",
    "Signups from this email domain are currently restricted.": "",
    "Something went wrong, please try again later.": "משהו השתבש, נסו שוב מאוחר יותר.",
    "Sorry, no paid plans are available.": "",
    "Sorry, no recommendations are available right now.": "מצטערים אך אין המלצות זמינות כעת.",
    "Sorry, that didn’t work.": "מצטערים, זה לא עבד",
    "Spam complaints": "תלונות ספאם",
    "Start {amount}-day free trial": "התחילו ניסיון חינם של {amount} ימים",
    "Starting {startDate}": "מתחיל ב {startDate}",
    "Starting today": "מתחיל היום",
    "Submit feedback": "שלחו פידבק",
    "Subscribe": "הרשמה",
    "Subscribed": "רשום",
    "Subscription plan updated successfully": "תוכנית המנוי עודכנה בהצלחה",
    "Success": "הצלחה",
    "Success! Check your email for magic link to sign-in.": "הצלחה! מצאו את לינק הקסם כדי להיכנס בתיבת המייל שלכם.",
    "Success! Your account is fully activated, you now have access to all content.": "הצלחה! החשבון שלכם הופעל באופן מלא, כעת יש לכם גישה לכל התכנים.",
    "Success! Your email is updated.": "הצלחה! המייל שלכם עודכן.",
    "Successfully unsubscribed": "הסרתם את המנוי בהצלחה",
    "Taylor Reid": "",
    "taylor@example.com": "",
    "Thank you for subscribing. Before you start reading, below are a few other sites you may enjoy.": "תודה על הרישום. לפני שתתחילו לקרוא, הנה כמה אתרים נוספים שאולי תהנו מהם.",
    "Thank you for your support": "תודה על התמיכה שלכם",
    "Thank you for your support!": "תודה על התמיכה שלכם!",
    "Thanks for the feedback!": "תודה על הפידבק!",
    "That didn't go to plan": "זה לא הלך כמתוכנן",
    "The email address we have for you is {memberEmail} — if that's not correct, you can update it in your <button>account settings area</button>.": "כתובת המייל שיש לנו עבורכם היא {memberEmail} — אם זה לא נכון, ניתן לעדכן אותה באזור <button>הגדרות החשבון</button>.",
    "There was a problem submitting your feedback. Please try again a little later.": "שגיאה בהגשת הפידבק שלכם. נסו שוב מאוחר יותר.",
    "There was an error cancelling your subscription, please try again.": "שגיאה בביטול המנוי שלכם, נסו שוב.",
    "There was an error continuing your subscription, please try again.": "שגיאה בהמשך המנוי שלכם, נסו שוב.",
    "There was an error processing your payment. Please try again.": "שגיאה בעיבוד התשלום שלכם. נסו שוב.",
    "There was an error sending the email, please try again": "שגיאה בשליחת המייל, נסו שוב",
    "This gift can only be redeemed once and expires on {expiryDate}.": "",
    "This gift has already been consumed.": "",
    "This gift has already been redeemed.": "",
    "This gift has been refunded.": "",
    "This gift has expired.": "",
    "This gift link is invalid.": "",
    "This site is invite-only, contact the owner for access.": "אתר זה פתוח למוזמנים בלבד, פנו לבעל האתר לגישה.",
    "This site is not accepting donations at the moment.": "",
    "This site is not accepting payments at the moment.": "אתר זה לא מקבל תשלומים כרגע.",
    "This site only accepts paid members.": "",
    "Threads": "",
    "Tier": "",
    "To": "",
    "To complete signup, click the confirmation link in your inbox. If it doesn't arrive within 3 minutes, check your spam folder!": "כדי לסיים את הרשמתכם, לחצו על לינק האישור בתיבת המייל שלכם. במידה ולא הגיע תוך 3 דקות, בדקו את תיבת הספאם!",
    "To continue to stay up to date, subscribe to {publication} below.": "כדי להישאר מעודכנים, הירשמו ל-{publication} למטה.",
    "Too many attempts try again in {number} days.": "יותר מדי ניסיונות, נסו שוב בעוד {number} ימים.",
    "Too many attempts try again in {number} hours.": "יותר מדי ניסיונות, נסו שוב בעוד {number} שעות.",
    "Too many attempts try again in {number} minutes.": "יותר מדי ניסיונות, נסו שוב בעוד {number} דקות.",
    "Too many different sign-in attempts, try again in {number} days": "יותר מדי ניסיונות כניסה שונים, נסו שוב בעוד {number} ימים",
    "Too many different sign-in attempts, try again in {number} hours": "יותר מדי ניסיונות כניסה שונים, נסו שוב בעוד {number} שעות",
    "Too many different sign-in attempts, try again in {number} minutes": "יותר מדי ניסיונות כניסה שונים, נסו שוב בעוד {number} דקות",
    "Too many sign-up attempts, try again later": "",
    "Try free for {amount} days, then {originalPrice}.": "נסו בחינם למשך {amount} ימים, ואז {originalPrice}.",
    "Unable to initiate checkout session": "בעיה בהתחלת סשן קופה",
    "Unlock access to all newsletters by becoming a paid subscriber.": "פתחו גישה לכל הניוזלטרים על ידי הפכתכם למנוי בתשלום.",
    "Unsubscribe from all emails": "הסירו את המנוי מכל המיילים",
    "Unsubscribed": "הסרתם את המנוי",
    "Unsubscribed from all emails.": "הסרתם את המנוי מכל המיילים.",
    "Unsubscribing from emails will not cancel your paid subscription to {title}": "הסרת המנוי מהמיילים לא תבטל את המנוי בתשלום שלכם ל-{title}",
    "Update": "עדכון",
    "Update your preferences": "עדכנו את ההעדפות שלכם",
    "Updates & announcements": "",
    "Verification link sent, check your inbox": "מייל אימות נשלח, בדקו את תיבת המייל שלכם",
    "Verify your email address is correct": "ודאו שכתובת המייל שלכם נכונה",
    "Verifying...": "",
    "View plans": "צפו בתוכניות",
    "We couldn't unsubscribe you as the email address was not found. Please contact the site owner.": "לא הצלחנו להסיר את המנוי שלכם מאחר שכתובת המייל לא נמצאה. פנו לבעל האתר.",
    "We'd hate to see you leave. How about a special offer to stay?": "",
    "We'll email it to the recipient on {deliveryDate}. A copy is in your inbox too.": "",
    "We'll email it to the recipient. A copy will be in your inbox too.": "",
    "Welcome back, {name}!": "ברוכים השבים, {name}!",
    "Welcome back!": "ברוכים השבים!",
    "Welcome to {siteTitle}": "ברוכים הבאים ל-{siteTitle}",
    "What's included": "",
    "When an inbox fails to accept an email it is commonly called a bounce. In many cases, this can be temporary. However, in some cases, a bounced email can be returned as a permanent failure when an email address is invalid or non-existent.": "כשספק מייל לא מקבל מייל נקרא זה הקפצה. ברוב המקרים, זה יכול להיות זמני. אך, במקרים מסוימים, מייל מוקפץ יכול להחזיר תקלה קבועה כאשר כתובת המייל אינה תקפה או לא קיימת.",
    "Why has my email been disabled?": "מדוע המייל שלי בוטל?",
    "X (Twitter)": "",
    "year": "שנה",
    "Yearly": "שנתי",
    "You already have an active subscription.": "",
    "You currently have a free membership, upgrade to a paid subscription for full access.": "יש לכם כרגע חשבון חופשי, שדרגו לחשבון בתשלום כדי לקבל גישה לכל התכנים.",
    "You have been successfully resubscribed": "נרשמתם מחדש בהצלחה",
    "You now have access to {tierName} until {expiryDate}. Enjoy!": "",
    "You're currently not receiving emails": "אתם לא מקבלים מיילים כרגע",
    "You're not receiving emails": "אתם לא מקבלים מיילים",
    "You're not receiving emails because you either marked a recent message as spam, or because messages could not be delivered to your provided email address.": "אתם לא מקבלים מיילים משום שסימנתם הודעה אחרונה כספאם, או משום שהודעות לא ניתנות לשליחה לכתובת המייל שסיפקתם.",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership_one": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership_two": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership_other": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_one": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_two": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_other": "",
    "You've been gifted a <strong>{duration}-year</strong> {tierName} membership": "",
    "You've been gifted a <strong>{duration}-year</strong> {tierName} membership to {siteTitle}": "",
    "You've been gifted a membership": "",
    "You've been gifted a membership to {siteTitle}": "",
    "You've successfully signed in.": "נכנסתם בהצלחה.",
    "You've successfully subscribed to <strong>{siteTitle}</strong>": "נרשמתם בהצלחה ל <strong>{siteTitle}</strong>",
    "Your account": "החשבון שלך",
    "Your email": "",
    "Your email has failed to resubscribe, please try again": "שגיאה בהרשמה מחדש עם כתובת המייל שלכם, נסו שוב",
    "Your gift is on its way": "",
    "Your gift is ready": "",
    "Your gift is scheduled": "",
    "Your gift subscription will expire on {expiryDate}": "",
    "your inbox": "",
    "Your input helps shape what gets published.": "המשוב שלכם עוזר לנו לעצב את התוכן שייפורסם.",
    "Your name": "",
    "Your subscription has been canceled and will expire on {expiryDate}.": "",
    "Your subscription will expire on {expiryDate}": "המינוי שלכם יפוג ב {expiryDate}",
    "Your subscription will renew on {renewalDate}": "המנוי שלכם יתחדש ב {renewalDate}",
    "Your subscription will start on {subscriptionStart}": "המנוי שלכם יתחיל ב {subscriptionStart}"
}
